<template>
  <div class="jsapi-pay">
    <div v-if="loading" class="jsapi-pay__loading">正在唤起微信支付...</div>
    <div v-if="error" class="jsapi-pay__error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: 'jsapi-pay',
  props: {
    applyResult: {
      type: String,
      default: ''
    },
    orderId: {
      type: String,
      default: ''
    },
    payMethod: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: true,
      error: ''
    }
  },
  methods: {
    onBridgeReady(payParams) {
      WeixinJSBridge.invoke('getBrandWCPayRequest', payParams, (res) => {
        this.loading = false
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          this.$router.push({
            name: 'pay-return',
            params: { payMethod: this.payMethod, id: this.orderId }
          })
        } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
          this.error = '支付已取消'
        } else {
          this.error = '支付失败，请重试'
        }
      })
    },
    invokePay() {
      let payParams = this.applyResult
      if (typeof payParams === 'string') {
        try {
          payParams = JSON.parse(payParams)
        } catch (e) {
          this.loading = false
          this.error = '支付参数异常'
          return
        }
      }

      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', () => this.onBridgeReady(payParams), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', () => this.onBridgeReady(payParams))
          document.attachEvent('onWeixinJSBridgeReady', () => this.onBridgeReady(payParams))
        }
      } else {
        this.onBridgeReady(payParams)
      }
    }
  },
  mounted() {
    this.invokePay()
  }
}
</script>

<style scoped lang="less">
.jsapi-pay {
  text-align: center;
  padding: 40px 20px;
  &__loading {
    color: #409eff;
    font-size: 20px;
  }
  &__error {
    color: #A30014;
    font-size: 20px;
    margin-top: 10px;
  }
}
</style>
